var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisinfectionA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.484,
    height: 76.097,
    viewBox: "0 0 48.484 76.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DisinfectionA",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(1.893 12.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-1",
    d: "M-3545.3-5196.368h0a7.109,7.109,0,0,1-7.1-7.1,7.054,7.054,0,0,1,2.079-5.021,7.06,7.06,0,0,1,5.022-2.079,7.109,7.109,0,0,1,7.1,7.1,7.052,7.052,0,0,1-2.079,5.021,7.053,7.053,0,0,1-5.022,2.081Zm0-10.967a3.844,3.844,0,0,0-2.734,1.131,3.844,3.844,0,0,0-1.131,2.734,3.869,3.869,0,0,0,3.865,3.865h0a3.841,3.841,0,0,0,2.734-1.132,3.837,3.837,0,0,0,1.131-2.733A3.87,3.87,0,0,0-3545.3-5207.334Z",
    transform: "translate(3561.777 5210.57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-1",
    d: "M-3584.794-5111.056a1.618,1.618,0,0,1-1.618-1.617,13.251,13.251,0,0,0-13.236-13.236,13.251,13.251,0,0,0-13.236,13.236,1.618,1.618,0,0,1-1.618,1.617,1.617,1.617,0,0,1-1.617-1.617,16.49,16.49,0,0,1,16.471-16.472,16.49,16.49,0,0,1,16.472,16.472A1.617,1.617,0,0,1-3584.794-5111.056Z",
    transform: "translate(3616.121 5141.121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-1",
    d: "M-3588.833-4852.015h-21.64a5.659,5.659,0,0,1-5.653-5.652v-6c0-.026,0-.051,0-.075a1.622,1.622,0,0,1,1.635-1.584,1.618,1.618,0,0,1,1.6,1.635v6.028a2.419,2.419,0,0,0,2.417,2.416h21.64a2.419,2.419,0,0,0,2.416-2.416v-6a1.618,1.618,0,0,1,1.618-1.618,1.617,1.617,0,0,1,1.617,1.618v6A5.659,5.659,0,0,1-3588.833-4852.015Z",
    transform: "translate(3616.126 4916.106)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(10.834 44.153)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-1",
    d: "M-3541.853-4948.431h-11.864a1.618,1.618,0,0,1-1.617-1.618,1.616,1.616,0,0,1,1.617-1.616h11.864a1.617,1.617,0,0,1,1.617,1.616A1.618,1.618,0,0,1-3541.853-4948.431Z",
    transform: "translate(3555.334 4957.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M-3513.388-4976.9a1.616,1.616,0,0,1-1.617-1.616v-11.864a1.617,1.617,0,0,1,1.617-1.618,1.618,1.618,0,0,1,1.618,1.618v11.864A1.617,1.617,0,0,1-3513.388-4976.9Z",
    transform: "translate(3520.937 4991.994)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M-3591.438-5277.167h-35.944a1.618,1.618,0,0,1-1.618-1.618v-11.8a1.622,1.622,0,0,1,.559-1.224,1.62,1.62,0,0,1,1.291-.377c.186.027,18.637,2.691,27.365,4,5.191.779,7.628,3.246,8.759,5.177a8.434,8.434,0,0,1,1.206,4.277A1.619,1.619,0,0,1-3591.438-5277.167Zm-34.326-3.236h32.4a5.79,5.79,0,0,0-.528-1.1c-1.149-1.849-3.291-3.019-6.369-3.481-7.083-1.062-20.581-3.019-25.5-3.731Z",
    transform: "translate(3629 5292.198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M-3367.121-5172.6a5.494,5.494,0,0,1-5.379-5.589,6.03,6.03,0,0,1,.035-.646,1.625,1.625,0,0,1,.067-.9l3.762-10.1a1.616,1.616,0,0,1,1.516-1.053h.009a1.618,1.618,0,0,1,1.513,1.068l3.318,9.2a5.787,5.787,0,0,1,.54,2.442A5.494,5.494,0,0,1-3367.121-5172.6Zm-2.027-6.594a1.642,1.642,0,0,1-.045.4,2.518,2.518,0,0,0-.072.6,2.258,2.258,0,0,0,2.144,2.353,2.259,2.259,0,0,0,2.145-2.353,2.5,2.5,0,0,0-.254-1.107,1.733,1.733,0,0,1-.068-.16l-1.846-5.12Z",
    transform: "translate(3410.225 5205.791)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-1",
    d: "M-3412.508-4954.74a1.618,1.618,0,0,1-1.618-1.618v-16.023a1.618,1.618,0,0,1,1.618-1.618,1.618,1.618,0,0,1,1.617,1.618v16.023A1.618,1.618,0,0,1-3412.508-4954.74Z",
    transform: "translate(3445.729 5020.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-1",
    d: "M-3614.5-4954.769a1.617,1.617,0,0,1-1.617-1.617v-16A1.618,1.618,0,0,1-3614.5-4974a1.618,1.618,0,0,1,1.618,1.618v16A1.618,1.618,0,0,1-3614.5-4954.769Z",
    transform: "translate(3618.014 5020.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisinfectionA);
export default __webpack_public_path__ + "static/media/DisinfectionA.cf611546.svg";
export { ForwardRef as ReactComponent };